import axios from 'axios'

import { Units } from 'common/server/units'

export function list() {
  return axios.get<Units>('/vendors/units')
}
